export const _toastVariants = {
    Warn: 'warn',
    Error: 'error',
    Success: 'success'
};